import * as Yup from "yup";

export const signInDetailsObject = {
  email: "",
  password: "",
  rememberMe: false,
};

export function objectFromFormData(formData) {
  return {
    email: formData.email,
    password: formData.password,
  };
}

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),
  password: Yup.string().max(255).required("Password is required"),
});
